import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const StepsLogPage = lazy(() => import("./StepsLogPage"));

const StepsLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <StepsLogPage />
    </Suspense>
  );
};

export default StepsLogPageLazy;
